<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">이용권 정산내역</span>
            <span class="txt">
                전체 직원의 매출/급여 를 확인하고, 직원 한 명의 자세한 매출/급여를 확인 및 금액수정을 할 수 있습니다.
            </span>
        </div>

        <div class="com-search-content">
            <div class="line">
                <select-form
                    :disabled="isDisableSelectStaffs"
                    :select-data="selectFormStaff.data"
                    :select-value="selectFormStaff.value"
                    :selected-value="selectedStaffId"
                    class="w160"
                    @update:set="(v) => (selectedStaffId = v)"
                ></select-form>
                <select-form
                    :select-data="['전체', '개인', 'OT', '듀엣', '그룹']"
                    :select-value="['', 'P', 'O', 'D', 'G']"
                    :selected-value="filter"
                    @update:set="(v) => (filter = v)"
                ></select-form>

                <div class="com-calendar-wrap center" style="position: relative; left: 0; top: 0; margin-left: +8px">
                    <button class="prev-day" style="height: 32px" @click="onClickBtnPrevMonth"></button>
                    <div class="ui-month-calendar">
                        <vue-monthly-picker v-model="monthlyPicker" dateFormat="YYYY년 MM월"></vue-monthly-picker>
                    </div>
                    <button style="height: 32px" class="next-day" @click="onClickBtnNextMonth"></button>
                </div>

                <div class="com-calendar-wrap" style="margin-left: 8px">
                    <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                    <div class="com-dash"><span class="dash">~</span></div>
                    <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                </div>

                <div class="right">
                    <button class="com-btn excel" @click="excelDownload">엑셀 다운로드</button>
                    <button v-if="payEdit == false" class="com-btn" @click="checkAllowedClick('PA', 6, calPriceEdit)">
                        정산금액 수정
                    </button>
                    <button v-if="payEdit == true" class="com-btn blue" @click="postEdit">입력완료</button>
                </div>
            </div>
        </div>

        <loading-spinner v-if="isLoading" :message='loadingMessage' />
        <span v-else>
            <div v-if="filter == 'P' || filter == ''" class="com-table-top">
                <span class="title">개인 정산내역</span>
                <table class="com-table">
                    <colgroup>
                        <col style="width: 100px" />
                        <col style="width: 280px" />
                        <col style="width: 120px" />
                        <col style="width: 110px" />
                        <col style="width: 200px" />
                        <col style="width: 200px" />
                        <col style="width: 100px" />
                        <col style="width: 200px" />
                        <col style="width: 120px" />
                        <col style="width: 80px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th v-for="(column, index) in tableHeader" :key="index">
                                <button @click="onClickDescOrASC(Object.values(column)[0], 'person', index)">
                                    {{ Object.values(column)[0].column }}
                                </button>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(p, index) in person.list" :key="index">
                            <td>
                                <router-link
                                    :to="{
                                        path: `/madmin/member/payment/${p.ctb_center_id}`,
                                        query: { customerId: p.cc_center_cust_id },
                                    }"
                                    class="link"
                                >
                                    {{ p.ctb_center_cust_nm }}
                                </router-link>
                            </td>
                            <td>{{ convertTicket(p.cp_ticket_type_cd) }} {{ p.cp_namee }} ({{ p.cp_less_time }}분)</td>
                            <td>{{ p.ctb_prod_buy_price | numberFormatFilter }}원</td>
                            <td>{{ p.ctb_less_cnt }}회</td>
                            <td>{{ convertLessonTm(p.ctb_less_dt, p.ctb_less_start_tm) }}</td>
                            <td>{{ convertTm(p.clsc_atnd_exec_tm) }}</td>
                            <td>
                                <span :class="{ red: p.clsc_atnd_status_cd == 'X' }">
                                    {{ convertStatus(p.clsc_atnd_status_cd) }}
                                </span>
                            </td>
                            <td>{{ convertTm(p.clsc_bill_exec_tm) }}</td>
                            <td class="tooltip-box">
                                <div
                                    class="balloon"
                                    style="box-shadow: 0px 0px 5px #00c7e5"
                                    v-if="p.ctb_bill_price !== lessonPersonPrice"
                                >
                                    <span class="txt">1회당 정산금액</span>
                                </div>
                                <span
                                    v-show="payEdit == false"
                                    class="txt"
                                    :style="
                                        lessonPersonType.includes('P')
                                            ? (p.cp_turn_bill_price * lessonPersonPrice) / 100 !== p.ctb_bill_price
                                                ? 'color: #00c7e5'
                                                : ''
                                            : p.ctb_bill_price !== lessonPersonPrice
                                            ? 'color: #00c7e5'
                                            : ''
                                    "
                                >
                                    {{ p.ctb_bill_price | numberFormatFilter }}
                                </span>
                                <!-- 수정일시 -->
                                <div v-show="payEdit == true" class="modify">
                                    <input v-model="p.editPrice" :disabled="!p.editHandBillYn" type="text" />
                                    <span class="txt">원</span>
                                </div>
                            </td>
                            <td>
                                <input
                                    v-model="p.editHandBillYn"
                                    :disabled="!payEdit"
                                    type="checkbox"
                                    @click="onChangeHandBillYn($event, p)"
                                />
                            </td>
                        </tr>
                        <tr v-if="person.list.length == 0">
                            <td colspan="100">등록된 내용이 없습니다.</td>
                        </tr>
                    </tbody>
                </table>
                <div class="total-count">
                    <span class="count">
                        <span class="txt">급여 합계</span>
                        <span class="num">{{ totalPrice | numberFormatFilter }} 원 ({{ totalConunt }}회)</span>
                    </span>
                </div>
            </div>

            <div v-if="filter == 'O' || filter == ''" class="com-table-top">
                <span class="title">OT 정산내역</span>
                <table class="com-table">
                    <colgroup>
                        <col style="width: 100px" />
                        <col style="width: 280px" />
                        <col style="width: 120px" />
                        <col style="width: 110px" />
                        <col style="width: 200px" />
                        <col style="width: 200px" />
                        <col style="width: 100px" />
                        <col style="width: 200px" />
                        <col style="width: 120px" />
                        <col style="width: 80px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th v-for="(column, index) in tableHeader2" :key="index">
                                <button @click="onClickDescOrASC(Object.values(column)[0], 'ot', index)">
                                    {{ Object.values(column)[0].column }}
                                </button>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(o, index) in ot.list" :key="index">
                            <td>
                                <router-link
                                    :to="{
                                        path: `/madmin/member/payment/${o.ctb_center_id}`,
                                        query: { customerId: o.cc_center_cust_id },
                                    }"
                                    class="link"
                                >
                                    {{ o.ctb_center_cust_nm }}
                                </router-link>
                            </td>
                            <td>{{ convertTicket(o.cp_ticket_type_cd) }} {{ o.cp_namee }} ({{ o.cp_less_time }}분)</td>
                            <td>{{ o.ctb_prod_buy_price | numberFormatFilter }}원</td>
                            <td>{{ o.ctb_less_cnt }}회</td>
                            <td>{{ convertLessonTm(o.ctb_less_dt, o.ctb_less_start_tm) }}</td>
                            <td>{{ convertTm(o.clsc_atnd_exec_tm) }}</td>
                            <td>
                                <span :class="{ red: o.clsc_atnd_status_cd == 'X' }">
                                    {{ convertStatus(o.clsc_atnd_status_cd) }}
                                </span>
                            </td>
                            <td>{{ convertTm(o.clsc_bill_exec_tm) }}</td>
                            <td class="tooltip-box">
                                <div
                                    class="balloon"
                                    style="box-shadow: 0px 0px 5px #00c7e5"
                                    v-if="o.ctb_bill_price != lessonOtPrice"
                                >
                                    <span class="txt">1회당 정산금액</span>
                                </div>
                                <span
                                    v-show="payEdit == false"
                                    class="txt"
                                    :style="
                                        lessonOtType.includes('P')
                                            ? (o.cp_turn_bill_price * lessonOtPrice) / 100 !== o.ctb_bill_price
                                                ? 'color: #00c7e5'
                                                : ''
                                            : o.ctb_bill_price !== lessonOtPrice
                                            ? 'color: #00c7e5'
                                            : ''
                                    "
                                >
                                    {{ o.ctb_bill_price | numberFormatFilter }} 원
                                </span>
                                <!-- 수정일시 -->
                                <div v-show="payEdit == true" class="modify">
                                    <input v-model="o.editPrice" :disabled="!o.editHandBillYn" type="text" />
                                    <span class="txt">원</span>
                                </div>
                            </td>
                            <td>
                                <input
                                    v-model="o.editHandBillYn"
                                    :disabled="!payEdit"
                                    type="checkbox"
                                    @click="onChangeHandBillYn($event, o)"
                                />
                            </td>
                        </tr>
                        <tr v-if="ot.list.length == 0">
                            <td colspan="100">등록된 내용이 없습니다.</td>
                        </tr>
                    </tbody>
                </table>
                <div class="total-count">
                    <span class="count">
                        <span class="txt">급여 합계</span>
                        <span class="num">{{ totalOtPrice | numberFormatFilter }} 원 ({{ totalOtConunt }}회)</span>
                    </span>
                </div>
            </div>

            <div v-if="filter == 'D' || filter == ''" class="com-table-top">
                <span class="title">듀엣 정산내역</span>
                <table class="com-table">
                    <colgroup>
                        <col style="width: 100px" />
                        <col style="width: 280px" />
                        <col style="width: 120px" />
                        <col style="width: 110px" />
                        <col style="width: 200px" />
                        <col style="width: 200px" />
                        <col style="width: 100px" />
                        <col style="width: 200px" />
                        <col style="width: 120px" />
                        <col style="width: 80px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th v-for="(column, index) in tableHeader3" :key="index">
                                <button @click="onClickDescOrASC(Object.values(column)[0], 'duet', index)">
                                    {{ Object.values(column)[0].column }}
                                </button>
                            </th>
                        </tr>
                    </thead>
                    <tbody v-for="(d, index) in duet.list" :key="index">
                        <tr v-for="(t, index) in d" :key="index">
                            <td>
                                <router-link
                                    :to="{
                                        path: `/madmin/member/payment/${t.details[0].ctb_center_id}`,
                                        query: { customerId: t.details[0].cc_center_cust_id },
                                    }"
                                    class="link"
                                >
                                    {{ t.details[0].ctb_center_cust_nm }}
                                </router-link>
                            </td>
                            <td>
                                {{ convertTicket(t.details[0].ctb_less_type_cd) }} {{ t.details[0].cp_namee }} ({{
                                    t.details[0].cp_less_time
                                }}분)
                            </td>
                            <td>{{ t.details[0].ctb_prod_buy_price | numberFormatFilter }}원</td>
                            <td>{{ t.details[0].ctb_less_cnt }}회</td>
                            <td>{{ convertLessonTm(t.details[0].cls_less_dt, t.details[0].cls_less_start_tm) }}</td>
                            <td>{{ convertTm(t.details[0].clsc_atnd_exec_tm) }}</td>
                            <td>
                                <span :class="{ red: t.details[0].clsc_atnd_status_cd == 'X' }">
                                    {{ convertStatus(t.details[0].clsc_atnd_status_cd) }}
                                </span>
                            </td>
                            <td>{{ convertTm(t.details[0].clsc_bill_exec_tm) }}</td>
                            <td>
                                <span
                                    v-show="!payEdit && isMemberStandard(DuetLessonPaySetting)"
                                    class="txt"
                                    :style="
                                        lessonDuetType.includes('P')
                                            ? (d.cp_turn_bill_price * lessonDuetPrice) / 100 !== d.ctb_bill_price
                                                ? 'color: #00c7e5'
                                                : ''
                                            : d.ctb_bill_price !== lessonDuetPrice
                                            ? 'color: #00c7e5'
                                            : ''
                                    "
                                >
                                    {{ t.details[0].ctb_bill_price | numberFormatFilter }} 원
                                </span>
                                <div v-show="payEdit && isMemberStandard(DuetLessonPaySetting)" class="modify">
                                    <input
                                        v-model="t.details[0].editPrice"
                                        :disabled="!t.details[0].editHandBillYn"
                                        type="number"
                                    />
                                    <span class="txt">원</span>
                                </div>
                            </td>
                            <td>
                                <input
                                    v-if="isMemberStandard(DuetLessonPaySetting)"
                                    v-model="t.details[0].editHandBillYn"
                                    :disabled="!payEdit"
                                    type="checkbox"
                                    @click="onChangeHandBillYn($event, t.details[0])"
                                />
                            </td>
                        </tr>
                        <tr class="total">
                            <td colspan="7"></td>
                            <td>
                                {{ convertLessonTm(d[0].details[0].cls_less_dt, d[0].details[0].cls_less_start_tm) }}
                            </td>
                            <td colspan="1">
                                <span v-show="!payEdit || isMemberStandard(DuetLessonPaySetting)" class="txt">
                                    {{ getClassTotalBillPrice(d, 'D') | numberFormatFilter }} 원 / {{ d.length }}명
                                </span>
                                <div v-show="payEdit && !isMemberStandard(DuetLessonPaySetting)" class="modify">
                                    <input
                                        v-model="duetInfo[index].editPrice"
                                        :disabled="!duetInfo[index].editHandBillYn"
                                        type="number"
                                    />
                                    <span class="txt">원</span>
                                </div>
                                <!-- <div class="modify">
                                    <input type="text" class="w100p">
                                    <span class="txt">원 / 2명</span>
                                </div> -->
                            </td>
                            <td>
                                <input
                                    v-if="!isMemberStandard(DuetLessonPaySetting)"
                                    v-model="duetInfo[index].editHandBillYn"
                                    :disabled="!payEdit"
                                    type="checkbox"
                                    @click="onChangeHandBillYn($event, duetInfo[index])"
                                />
                            </td>
                        </tr>
                        <tr v-if="duet.list.length == 0">
                            <td colspan="100">등록된 내용이 없습니다.</td>
                        </tr>
                    </tbody>
                </table>
                <div class="total-count">
                    <span class="count">
                        <span class="txt">급여 합계</span>
                        <span class="num">{{ totalDuetPrice | numberFormatFilter }} 원 ({{ totalDuetCount }}회)</span>
                    </span>
                </div>
            </div>

            <div v-if="filter == 'G' || filter == ''" class="com-table-top">
                <span class="title">그룹(쿠폰) 정산내역</span>
                <table class="com-table">
                    <colgroup>
                        <col style="width: 100px" />
                        <col style="width: 280px" />
                        <col style="width: 120px" />
                        <col style="width: 110px" />
                        <col style="width: 200px" />
                        <col style="width: 200px" />
                        <col style="width: 100px" />
                        <col style="width: 200px" />
                        <col style="width: 120px" />
                        <col style="width: 80px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th v-for="(column, index) in tableHeader4" :key="index">
                                <button @click="onClickDescOrASC(Object.values(column)[0], 'group', index)">
                                    {{ Object.values(column)[0].column }}
                                </button>
                            </th>
                        </tr>
                    </thead>
                    <tbody v-for="(g, index) in group.list" :key="index">
                        <tr v-for="(d, index) in g" :key="index">
                            <td>
                                <router-link
                                    :to="{
                                        path: `/madmin/member/payment/${d.details[0].ctb_center_id}`,
                                        query: { customerId: d.details[0].cc_center_cust_id },
                                    }"
                                    class="link"
                                >
                                    {{ d.details[0].ctb_center_cust_nm }}
                                </router-link>
                            </td>
                            <td>
                                {{ convertTicket(d.details[0].cp_ticket_type_cd) }} {{ d.details[0].cp_namee }} ({{
                                    d.details[0].cp_less_time
                                }}분)
                            </td>
                            <td>{{ d.details[0].ctb_prod_buy_price | numberFormatFilter }}원</td>
                            <td>
                                {{ convertTypeCd(d.details[0].cp_less_cnt_type_cd) }} {{ d.details[0].ccp_less_cnt }} 회
                            </td>
                            <td>{{ convertLessonTm(d.details[0].cls_less_dt, d.details[0].cls_less_start_tm) }}</td>
                            <td>{{ convertTm(d.details[0].clsc_atnd_exec_tm) }}</td>
                            <td>
                                <span :class="{ red: d.details[0].clsc_atnd_status_cd == 'X' }">
                                    {{ convertStatus(d.details[0].clsc_atnd_status_cd) }}
                                </span>
                            </td>
                            <td>{{ convertTm(d.details[0].clsc_bill_exec_tm) }}</td>
                            <td>
                                <span v-show="!payEdit && isMemberStandard(GroupLessonPaySetting)">
                                    {{ d.details[0].ctb_bill_price | numberFormatFilter }}
                                </span>
                                <div v-show="payEdit && isMemberStandard(GroupLessonPaySetting)" class="modify">
                                    <input
                                        v-model="d.details[0].editPrice"
                                        :disabled="!d.details[0].editHandBillYn"
                                        type="number"
                                    />
                                    <span class="txt">원</span>
                                </div>
                            </td>
                            <td>
                                <input
                                    v-if="isMemberStandard(GroupLessonPaySetting)"
                                    v-model="d.details[0].editHandBillYn"
                                    :disabled="!payEdit"
                                    type="checkbox"
                                    @click="onChangeHandBillYn($event, d.details[0])"
                                />
                            </td>
                        </tr>
                        <tr class="total">
                            <td colspan="7"></td>
                            <td>
                                {{ convertLessonTm(g[0].details[0].cls_less_dt, g[0].details[0].cls_less_start_tm) }}
                            </td>
                            <td>
                                <span v-show="!payEdit || isMemberStandard(GroupLessonPaySetting)" class="txt">
                                    {{ getClassTotalBillPrice(g, 'G') | numberFormatFilter }}원 / {{ g.length }}명
                                </span>
                                <div v-show="payEdit && !isMemberStandard(GroupLessonPaySetting)" class="modify">
                                    <input
                                        v-model="groupInfo[index].editPrice"
                                        :disabled="!groupInfo[index].editHandBillYn"
                                        type="number"
                                    />
                                    <span class="txt">원</span>
                                </div>
                            </td>
                            <td>
                                <input
                                    v-if="!isMemberStandard(GroupLessonPaySetting)"
                                    v-model="groupInfo[index].editHandBillYn"
                                    :disabled="!payEdit"
                                    type="checkbox"
                                    @click="onChangeHandBillYn($event, groupInfo[index])"
                                />
                            </td>
                        </tr>
                        <tr v-if="group.list.length == 0">
                            <td colspan="100">등록된 내용이 없습니다.</td>
                        </tr>
                    </tbody>
                </table>
                <div class="total-count">
                    <span class="count">
                        <span class="txt">급여 합계</span>
                        <span class="num">{{ totalGroupPrice | numberFormatFilter }} 원 ({{ totalGroupCount }}회)</span>
                    </span>
                </div>
            </div>
        </span>
    </div>
</template>

<script>
import moment from 'moment';
import api from '@/assets/js/api';
import { Utils } from '@/assets/js/utils';
import XLSX from 'xlsx';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';

export default {
    name: 'SalaryUse',
    mixins: [MixinAllowedMenu],
    props: {},
    watch: {
        selectedStaffId(v) {
            this.selectedStaffId = v;
            this.paySettingDetail();
            this.refrechAllList();
        },
        monthlyPicker(val) {
            this.startDate = moment(val).format('YYYY-MM-01');
            this.endDate = moment(val).format('YYYY-MM-') + moment(val).daysInMonth();
            this.paySettingDetail();
            this.refrechAllList();
        },
        filter(v) {
            //
            this.filter = v;
        },
    },
    computed: {
        selectedMonth() {
            return this.monthlyPicker.format('YYYY-MM');
        },
        totalPrice() {
            // 개인값 계산
            let result = 0;
            for (const i in this.person.list) {
                result += this.person.list[i].ctb_bill_price;
            }
            this.tp = result;
            return result;
        },
        totalConunt() {
            return this.person.list.length;
        },
        totalOtPrice() {
            // OT값 계산
            let result = 0;
            for (const i in this.ot.list) {
                result += this.ot.list[i].ctb_bill_price;
            }
            this.top = result;
            return result;
        },
        totalOtConunt() {
            return this.ot.list.length;
        },
        totalDuetPrice() {
            // 듀엣값 계산
            let result = 0;
            for (const item of this.duet.list) {
                result += this.getClassTotalBillPrice(item, 'D');
            }
            this.tdp = result;
            return result;
        },
        totalDuetCount() {
            return this.duet.list.length;
        },
        totalGroupPrice() {
            // 그룹값 계신
            let result = 0;

            for (const item of this.group.list) {
                result += this.getClassTotalBillPrice(item, 'G');
            }
            this.tgp = result;
            return result;
        },
        totalGroupCount() {
            return this.group.list.length;
        },
    },
    data() {
        return {
            startDate: moment().format('YYYY-MM-01'),
            endDate: moment().format('YYYY-MM-') + moment().daysInMonth(),
            count: 0,

            isLoading: false,
            loadingMessage: '',

            centerId: '',
            isDisableSelectStaffs: true,
            payEdit: false,
            filter: '',
            monthlyPicker: moment(), // 년월 설정
            selectedStaffId: '',
            selectFormStaff: {
                data: ['-------------'],
                value: ['-------------'],
            },
            person: {
                list: [],
            },
            ot: {
                list: [],
            },
            duet: {
                list: [],
            },
            group: {
                list: [],
            },
            duetInfo: [],
            groupInfo: [],
            editPrice: [], // 수정되는 가격(개인)
            editPriceOt: [], // 수정되는 가격(OT)
            editPriceDuet: [],
            editPriceGroup: [],

            tickBillId: '', // 수정되는 아이템 값
            billPrice: '', // 실제 정산 수정되는 가격
            inArray: [],
            inArrayValue: [],
            outArray: [],
            outArrayValue: [],
            GroupLessonPaySetting: '', // 그룹레슨 페이 설정 정보 세팅
            DuetLessonPaySetting: '', // 듀엣 급여 설정 정보 세팅

            // 테이블 헤더와 엑셀 다운로드를 할 때 사용하기 위해서 선언. ascOrDesc가 f
            tableHeader: [
                {
                    center_cust_nm: {
                        column: '회원명',
                        key: 'center_cust_nm',
                        sortType: 0,
                    },
                },
                {
                    prod_nm: {
                        column: '이용권명',
                        key: 'prod_nm',
                        sortType: 0,
                    },
                },
                {
                    prod_buy_price: {
                        column: '구매가',
                        key: 'prod_buy_price',
                        sortType: 0,
                    },
                },
                {
                    less_cnt: {
                        column: '횟수',
                        key: 'less_cnt',
                        sortType: 'DESC',
                    },
                },
                {
                    less_dt: {
                        column: '수업일자',
                        key: 'less_dt',
                        sortType: 0,
                    },
                },
                {
                    atnd_exec_tm: {
                        column: '출결승인',
                        key: 'atnd_exec_tm',
                        sortType: 0,
                    },
                },
                {
                    atnd_dev_cd: {
                        column: '출결여부',
                        key: 'atnd_dev_cd',
                        sortType: 0,
                    },
                },
                {
                    cre_dt: {
                        column: '정산일자',
                        key: 'cre_dt',
                        sortType: 0,
                    },
                },
                {
                    bill_price: {
                        column: '정산금액',
                        key: 'bill_price',
                        sortType: 0,
                    },
                },
                {
                    editHandBillYn: {
                        column: '수기여부',
                        key: 'editHandBillYn',
                        sortType: 0,
                    },
                },
            ],
            tableHeader2: [
                {
                    center_cust_nm: {
                        column: '회원명',
                        key: 'center_cust_nm',
                        sortType: 0,
                    },
                },
                {
                    prod_nm: {
                        column: '이용권명',
                        key: 'prod_nm',
                        sortType: 0,
                    },
                },
                {
                    prod_buy_price: {
                        column: '구매가',
                        key: 'prod_buy_price',
                        sortType: 0,
                    },
                },
                {
                    less_cnt: {
                        column: '횟수',
                        key: 'less_cnt',
                        sortType: 0,
                    },
                },
                {
                    less_dt: {
                        column: '수업일자',
                        key: 'less_dt',
                        sortType: 0,
                    },
                },
                {
                    atnd_exec_tm: {
                        column: '출결승인',
                        key: 'atnd_exec_tm',
                        sortType: 0,
                    },
                },
                {
                    atnd_dev_cd: {
                        column: '출결여부',
                        key: 'atnd_dev_cd',
                        sortType: 0,
                    },
                },
                {
                    cre_dt: {
                        column: '정산일자',
                        key: 'cre_dt',
                        sortType: 0,
                    },
                },
                {
                    bill_price: {
                        column: '정산금액',
                        key: 'bill_price',
                        sortType: 0,
                    },
                },
                {
                    editHandBillYn: {
                        column: '수기여부',
                        key: 'editHandBillYn',
                        sortType: 0,
                    },
                },
            ],
            tableHeader3: [
                {
                    center_cust_nm: {
                        column: '회원명',
                        key: 'center_cust_nm',
                        sortType: 0,
                    },
                },
                {
                    prod_nm: {
                        column: '이용권명',
                        key: 'prod_nm',
                        sortType: 0,
                    },
                },
                {
                    prod_buy_price: {
                        column: '구매가',
                        key: 'prod_buy_price',
                        sortType: 0,
                    },
                },
                {
                    less_cnt: {
                        column: '횟수',
                        key: 'less_cnt',
                        sortType: 0,
                    },
                },
                {
                    less_dt: {
                        column: '수업일자',
                        key: 'less_dt',
                        sortType: 0,
                    },
                },
                {
                    atnd_exec_tm: {
                        column: '출결승인',
                        key: 'atnd_exec_tm',
                        sortType: 0,
                    },
                },
                {
                    atnd_dev_cd: {
                        column: '출결여부',
                        key: 'atnd_dev_cd',
                        sortType: 0,
                    },
                },
                {
                    cre_dt: {
                        column: '정산일자',
                        key: 'cre_dt',
                        sortType: 0,
                    },
                },
                {
                    bill_price: {
                        column: '정산금액',
                        key: 'bill_price',
                        sortType: 0,
                    },
                },
                {
                    editHandBillYn: {
                        column: '수기여부',
                        key: 'editHandBillYn',
                        sortType: 0,
                    },
                },
            ],
            tableHeader4: [
                {
                    center_cust_nm: {
                        column: '회원명',
                        key: 'center_cust_nm',
                        sortType: 0,
                    },
                },
                {
                    prod_nm: {
                        column: '이용권명',
                        key: 'prod_nm',
                        sortType: 0,
                    },
                },
                {
                    prod_buy_price: {
                        column: '구매가',
                        key: 'prod_buy_price',
                        sortType: 0,
                    },
                },
                {
                    less_cnt: {
                        column: '횟수',
                        key: 'less_cnt',
                        sortType: 0,
                    },
                },
                {
                    less_dt: {
                        column: '수업일자',
                        key: 'less_dt',
                        sortType: 0,
                    },
                },
                {
                    atnd_exec_tm: {
                        column: '출결승인',
                        key: 'atnd_exec_tm',
                        sortType: 0,
                    },
                },
                {
                    atnd_dev_cd: {
                        column: '출결여부',
                        key: 'atnd_dev_cd',
                        sortType: 0,
                    },
                },
                {
                    cre_dt: {
                        column: '정산일자',
                        key: 'cre_dt',
                        sortType: 0,
                    },
                },
                {
                    bill_price: {
                        column: '정산금액',
                        key: 'bill_price',
                        sortType: 0,
                    },
                },
                {
                    editHandBillYn: {
                        column: '수기여부',
                        key: 'editHandBillYn',
                        sortType: 0,
                    },
                },
            ],
            //  급여합계를 저장
            tp: 0,
            top: 0,
            tdp: 0,
            tgp: 0,

            sortColumn: '',
            sortType: '',
            lessonType: '',

            lessonPersonPrice: '',
            lessonOtPrice: '',
            lessonDuetPrice: '',

            lessonOtType: '',
            lessonPersonType: '',
            lessonDuetType: '',
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        // 검색 시작일 변경 event
        startDateUpdate(value) {
            this.startDate = value;
            if (this.count > 1) {
                // this.paySettingDetail();
                this.refrechAllList();
            } else {
                this.count++;
            }
        },
        // 검색 시작일 변경 event
        endDateUpdate(value) {
            this.endDate = value;
            if (this.count > 1) {
                // this.paySettingDetail();
                this.refrechAllList();
            } else {
                this.count++;
            }
        },
        async init() {
            try {
                this.isLoading = true;
                this.loadingMessage = '급여정산 중입니다.\n잠시만 기다려 주세요.';

                this.centerId = this.$store.getters['auth/cId'];
                await this.teacherList();
                await this.fetchCenterStaffAllList();
                await this.paySettingDetail(); // 스태프 페이 설정 정보 불러오기
                await this.refrechAllList();
            } catch (error) {
                console.error(error);
            } finally {
                this.isLoading = false;
            }
        },
        // 급여설정 세팅 정보 조회
        async paySettingDetail() {
            const { data } = await api.get(
                `/admin/api/center/${this.centerId}/staff/${this.selectedStaffId}/pay/setting/detail`,
                {
                    params: {
                        applyDate: moment(this.monthlyPicker).format('YYYY-MM-01'),
                    },
                }
            );
            console.log('paySetting', data);
            this.lessonOtPrice = data.lessonOtPrice;
            this.lessonPersonPrice = data.lessonPersonPrice;
            this.lessonDuetPrice = data.lessonDuetPrice;
            this.DuetLessonPaySetting = data.lessonDuetType;
            this.GroupLessonPaySetting = data.lessonGroupType;
            this.lessonOtType = data.lessonOtType;
            this.lessonDuetType = data.lessonDuetType;
            this.lessonPersonType = data.lessonPersonType;
        },

        // 강사목록
        async teacherList() {
            try {
                const inStaff = await this.getTeacherList('I'); // 입사
                const outStaff = await this.getTeacherList('O'); // 퇴사
                inStaff.data.items.sort((a, b) =>
                    // order by 정렬
                    a.c_namee < b.c_namee ? -1 : a.c_namee > b.c_namee ? 1 : 0
                );
                const inArray = [];
                const inArrayValue = [];
                const outArray = [];
                const outArrayValue = [];
                inStaff.data.items.forEach((g) => {
                    inArray.push(g.c_namee);
                    inArrayValue.push(g.c_center_staff_id);
                });
                outStaff.data.items.forEach((g) => {
                    outArray.push(`${g.c_namee}-퇴사`);
                    outArrayValue.push(g.c_center_staff_id);
                });
                this.selectFormStaff.data = [...inArray, '------', outArray];
                this.selectFormStaff.value = [...inArrayValue, '------', outArrayValue];
            } catch (error) {
                console.log(error);
            }
        },
        getTeacherList(types) {
            return api.get(`/admin/api/center/${this.centerId}/staff/all/pagaing`, {
                params: {
                    page: 1,
                    limit: 1000,
                    status: types, // 입사I 퇴사 O
                },
            });
        },
        async refrechAllList() {
            // this.fetchStaffSales();
            this.person.list = [];
            this.ot.list = [];
            this.duet.list = [];
            this.group.list = [];
            await this.onPersonList(); // 개인이용권
            await this.onOtList(); // ot list
            await this.onDuetList(); // duet list
            await this.onGroupList(); // group list
        },
        async excelDownload() {
            // 엑셀 다운로드 기능구현

            const { person, ot, duet, group, tableHeader } = this;

            if (person.list.length == 0 && ot.list.length == 0 && duet.list.length == 0 && group.list.length == 0) {
                return;
            }
            const wb = XLSX.utils.book_new();
            const wscols = [
                { wch: 9 },
                { wch: 40 },
                { wch: 12 },
                { wch: 6 },
                { wch: 25 },
                { wch: 25 },
                { wch: 10 },
                { wch: 23 },
                { wch: 10, t: 'n', z: '#,##0' },
            ];
            // cell height 설정
            const wsrows = [{ hpx: 30 }];
            // 엑셀 셀 스타일..

            const excelData = [];
            if (person.list.length != 0) {
                // const personExcelData = [];

                person.list.forEach((val) => {
                    const arrayData = {
                        회원명: val.ctb_center_cust_nm,
                        이용권명: `${this.convertTicket(val.cp_ticket_type_cd)} ${val.cp_namee}(${val.cp_less_time})분`,
                        구매가: `${val.ctb_prod_buy_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원`,
                        횟수: val.ctb_less_cnt,
                        수업일자: this.convertLessonTm(val.ctb_less_dt, val.ctb_less_start_tm),
                        출결승인: this.convertTm(val.clsc_atnd_exec_tm),
                        출결여부: this.convertStatus(val.clsc_atnd_status_cd),
                        정산일자: this.convertTm(val.clsc_bill_exec_tm),
                        정산금액: val.editPrice,
                    };
                    excelData.push(arrayData);
                });
                excelData.push({
                    회원명: '',
                    이용권명: '',
                    구매가: '',
                    횟수: '',
                    수업일자: '',
                    출결승인: '',
                    출결여부: '',
                    정산일자: '',
                    정산금액:
                        `급여 합계: ${this.tp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원` +
                        `(${person.list.length}회)`,
                });
                // const ws = XLSX.utils.json_to_sheet(personExcelData); // 배열을 넣어야함.
                // ws['!cols'] = wscols;
                // ws['!rows'] = wsrows;
                // XLSX.utils.book_append_sheet(wb, ws, '개인 정산내역');
            }

            if (ot.list.length != 0) {
                // const otExcelData = [];

                ot.list.forEach((val) => {
                    const arrayData = {
                        회원명: val.ctb_center_cust_nm,
                        이용권명: `${this.convertTicket(val.cp_ticket_type_cd)} ${val.cp_namee}(${val.cp_less_time})분`,
                        구매가: `${val.ctb_prod_buy_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원`,
                        횟수: val.ctb_less_cnt,
                        수업일자: this.convertLessonTm(val.ctb_less_dt, val.ctb_less_start_tm),
                        출결승인: this.convertTm(val.clsc_atnd_exec_tm),
                        출결여부: this.convertStatus(val.clsc_atnd_status_cd),
                        정산일자: this.convertTm(val.clsc_bill_exec_tm),
                        정산금액: val.editPrice,
                    };
                    excelData.push(arrayData);
                });
                excelData.push({
                    회원명: '',
                    이용권명: '',
                    구매가: '',
                    횟수: '',
                    수업일자: '',
                    출결승인: '',
                    출결여부: '',
                    정산일자: '',
                    정산금액:
                        `급여 합계: ${this.top.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원` +
                        `(${ot.list.length}회)`,
                });
                // const ws = XLSX.utils.json_to_sheet(otExcelData); // 배열을 넣어야함.
                // ws['!cols'] = wscols;
                // ws['!rows'] = wsrows;
                // XLSX.utils.book_append_sheet(wb, ws, '이용권정산내역');
            }

            if (duet.list.length != 0) {
                // const duetExcelData = [];

                duet.list.forEach((val) => {
                    let arrayData = {};
                    val.forEach((intoVal) => {
                        arrayData = {
                            회원명: intoVal.details[0].clsc_center_cust_nm,
                            이용권명: `${this.convertTicket(intoVal.details[0].ctb_less_type_cd)} ${
                                intoVal.details[0].cp_namee
                            }(${intoVal.details[0].cp_less_time})분`,
                            구매가: `${intoVal.details[0].ctb_prod_buy_price
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원`,
                            횟수: `${intoVal.details[0].ctb_less_cnt}회`,
                            수업일자: this.convertLessonTm(
                                intoVal.details[0].cls_less_dt,
                                intoVal.details[0].cls_less_start_tm
                            ),
                            출결승인: this.convertTm(intoVal.details[0].clsc_atnd_exec_tm),
                            출결여부: this.convertStatus(intoVal.details[0].clsc_atnd_status_cd),
                            정산일자: this.convertTm(intoVal.details[0].clsc_bill_exec_tm),
                            정산금액:
                                // parseInt(`${intoVal.details[0].ctb_bill_price.toString()
                                //     .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                // }`,10),
                                intoVal.details[0].ctb_bill_price,
                        };
                        excelData.push(arrayData);
                    });
                });
                excelData.push({
                    회원명: '',
                    이용권명: '',
                    구매가: '',
                    횟수: '',
                    수업일자: '',
                    출결승인: '',
                    출결여부: '',
                    정산일자: '',
                    정산금액:
                        `급여 합계: ${this.tdp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원` +
                        `(${duet.list.length}회)`,
                });
                // const ws = XLSX.utils.json_to_sheet(duetExcelData); // 배열을 넣어야함.
                // ws['!cols'] = wscols;
                // ws['!rows'] = wsrows;
                // XLSX.utils.book_append_sheet(wb, ws, '이용권정산내역');
            }

            if (group.list.length != 0) {
                // const groupExcelData = [];

                group.list.forEach((val) => {
                    let arrayData = {};
                    let totalPrice = 0;
                    val.forEach((intoVal) => {
                        arrayData = {
                            회원명: intoVal.details[0].ctb_center_cust_nm,
                            이용권명: `${this.convertTicket(intoVal.details[0].cp_ticket_type_cd)} ${
                                intoVal.details[0].cp_namee
                            }(${intoVal.details[0].cp_less_time})분`,
                            구매가: `${intoVal.details[0].ctb_prod_buy_price
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원`,
                            횟수: `${intoVal.details[0].ctb_less_cnt}회`,
                            수업일자: this.convertLessonTm(
                                intoVal.details[0].cls_less_dt,
                                intoVal.details[0].cls_less_start_tm
                            ),
                            출결승인: this.convertTm(intoVal.details[0].clsc_atnd_exec_tm),
                            출결여부: this.convertStatus(intoVal.details[0].clsc_atnd_status_cd),
                            // "정산일자":this.convertTm(val.clsc_bill_exec_tm),
                            // "정산금액":val.editPrice+"원",
                        };
                        excelData.push(arrayData);
                    });

                    totalPrice = this.getClassTotalBillPrice(val, 'G');

                    const arrayDataMerge = {
                        회원명: '',
                        이용권명: '',
                        구매가: '',
                        횟수: '',
                        수업일자: '',
                        출결승인: '',
                        출결여부: '',
                        정산일자: this.convertLessonTm(
                            val[0].details[0].cls_less_dt,
                            val[0].details[0].cls_less_start_tm
                        ),
                        // 정산금액: parseInt(`${totalPrice.toString()
                        //     .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`, 10),
                        정산금액: totalPrice,
                    };
                    excelData.push(arrayDataMerge);
                });
                excelData.push({
                    회원명: '',
                    이용권명: '',
                    구매가: '',
                    횟수: '',
                    수업일자: '',
                    출결승인: '',
                    출결여부: '',
                    정산일자: '',
                    정산금액:
                        `급여 합계: ${this.tgp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}원` +
                        `(${group.list.length}회)`,
                });
            }
            const ws = XLSX.utils.json_to_sheet(excelData); // 배열을 넣어야함.
            ws['!cols'] = wscols;
            ws['!rows'] = wsrows;
            Object.keys(ws).map((key, index) => {
                if (key.includes('I') && ws[key].t === 'n') {
                    ws[key] = { ...ws[key], z: '#,##0' };
                }
            });
            console.log(ws);
            XLSX.utils.book_append_sheet(wb, ws, '이용권정산내역');
            XLSX.writeFile(wb, '이용권정산내역.xlsx');
        },
        async fetchCenterStaffAllList() {
            try {
                const staffId = parseInt(this.$store.getters['auth/staffId']);
                const staffName = this.$store.getters['auth/userName'];

                // 자기 자신이 기본값
                let selectFormObj = {
                    data: [staffName],
                    value: [staffId],
                };

                this.isDisableSelectStaffs = true;

                // 권한에 따라 조회 가능한 직원 지정
                if (this.isAllowed('PA', 3)) {
                    // 전체 직원 조회 가능
                    const { data } = await this.getCenterStaffAllList();
                    data.sort((a, b) =>
                        // order by 정렬
                        a.name < b.name ? -1 : a.name > b.name ? 1 : 0
                    );
                    selectFormObj = Utils.getSelectFormObjectFromArray('name', 'centerStaffId', data);
                    this.isDisableSelectStaffs = false;
                } else if (this.isAllowed('PA', 2)) {
                    // 동일한 팀의 직원 조회 가능
                    const { data } = await this.getCenterSameTeamStaffList();
                    // 팀이 없는 경우, 기본값인 자신만 노출
                    if (data.length > 0) {
                        selectFormObj = Utils.getSelectFormObjectFromArray('namee', 'center_staff_id', data);
                    }
                    this.isDisableSelectStaffs = false;
                }

                this.selectFormStaff.data = selectFormObj.data;
                this.selectFormStaff.value = selectFormObj.value;
                this.$route.query.staffId
                    ? (this.selectedStaffId = Number(this.$route.query.staffId))
                    : (this.selectedStaffId = staffId);
                this.$route.query.selectData ? (this.filter = this.$route.query.selectData) : '';
                this.$route.query.month
                    ? (this.monthlyPicker = moment(this.$route.query.month).format('YYYYMM'))
                    : moment();
            } catch (e) {
                console.log(e);
            }
        },
        getCenterSameTeamStaffList() {
            const centerStaffId = this.$store.getters['auth/staffId'];
            return api.get(`/admin/api/center/${this.centerId}/staff/${centerStaffId}/sameTeamStaffs`);
        },
        async fetchStaffSales() {
            try {
                // 신규 매출
                const { data: newData } = await this.getCenterStaffAllSumNewRegister(this.selectedStaffId);
                this.staffSales.newData = newData;
                this.staffSales.sumNewData = this.sumStaffSales(newData, 'ccp_bill_info');
                const sumNewDataReturn = Utils.sumFromListByFieldName(newData, 'ccp_turn_bill_price');
                this.staffSales.sumNewData -= sumNewDataReturn;

                // 재등록 매출
                const { data: reData } = await this.getCenterStaffAllSumReregister(this.selectedStaffId);
                this.staffSales.reData = reData;
                this.staffSales.sumReData = this.sumStaffSales(reData, 'ccp_bill_info');
                const sumReDataReturn = Utils.sumFromListByFieldName(reData, 'ccp_turn_bill_price');
                this.staffSales.sumReData -= sumReDataReturn;

                // 목록을 합친 후 결제일자 별로 정렬 필요
                this.staffSales.list = [...this.staffSales.reData, ...this.staffSales.newData];
                this.staffSales.list.sort((a, b) => new Date(a.ccp_buy_date) - new Date(b.ccp_buy_date));
            } catch (e) {
                console.log(e);
            }
        },
        getCenterStaffAllList() {
            return api.get(`/admin/api/center/${this.centerId}/staff/teachers/list`);
        },
        getCenterReportPerformance(type) {
            const tickBillDate = this.selectedMonth.replaceAll('-');
            const params = {
                tickBillDate,
            };
            return api.get(
                `/admin/api/center/${this.centerId}/report/preformance/${type}/staff/${this.selectedStaffId}`,
                { params }
            );
        },
        getCenterStaffAllSumNewRegister(staffId) {
            return this.getCenterStaffAllSum(staffId, 'N');
        },
        getCenterStaffAllSumReregister(staffId) {
            return this.getCenterStaffAllSum(staffId, 'R');
        },
        getCenterStaffAllSum(staffId, lessStaffContractType) {
            // 직원 총매출 조회
            const [billYear, billMonth] = this.selectedMonth.split('-');
            const params = {
                lessStaffContractType,
                billYear,
                billMonth,
            };
            const url = `/admin/api/center/${this.centerId}/salary/staff/${staffId}/total-sales`;
            return api.get(url, { params });
        },
        onClickBtnNextMonth() {
            this.monthlyPicker = moment(this.monthlyPicker).add(1, 'months');
        },
        onClickBtnPrevMonth() {
            this.monthlyPicker = moment(this.monthlyPicker).subtract(1, 'months');
        },
        sumStaffSales(list, fieldName) {
            let sum = 0;

            for (const item of list) {
                if (Utils.isEmpty(item[fieldName])) {
                    continue;
                }

                const paymentArr = item[fieldName].split('|');
                for (const payment of paymentArr) {
                    const [paymentType, amount] = payment.split('_');
                    sum += parseInt(amount);
                }
            }

            return sum;
        },
        isTurnItem(item) {
            return !Utils.isEmpty(item.ccp_turn_bill_price) && item.ccp_turn_bill_price > 0;
        },
        getPaymentString(str) {
            return Utils.getPaymentString(str);
        },
        // 이용권 정산내역
        async onPersonList() {
            try {
                const { data } = await this.getPersonList();
                this.person.list = data;

                this.person.list.forEach((p) => {
                    p.editPrice = p.ctb_bill_price;
                    p.editHandBillYn = p.ctb_hand_bill_yn;
                });
                // this.person.list = this.person.list.sort((a,b) =>{
                //     return a.ctb_less_dt < b.ctb_less_dt ? -1 : 1
                // })
            } catch (error) {
                console.log(error);
            }
        },
        getPersonList() {
            // 스웨거 검색: 이용권정산내역(개인) 목록 조회
            return api.get(
                `/admin/api/center/${this.centerId}/salary/ticket/calculate/person/staff/${this.selectedStaffId}`,
                {
                    params: {
                        startDate: this.startDate,
                        endDate: this.endDate,
                        sortColumn: this.sortColumn,
                        sortType: this.sortType,
                        lessonType: this.lessonType,
                    },
                }
            );
        },
        // OT 정산내역
        async onOtList() {
            try {
                const { data } = await this.getOtList();
                this.ot.list = data;

                this.ot.list.forEach((o) => {
                    o.editPrice = o.ctb_bill_price;
                    o.editHandBillYn = o.ctb_hand_bill_yn;
                });
                this.ot.list = this.ot.list.sort(a, (b) => {
                    return a.ctb_less_dt < b.ctb_less_dt ? -1 : 1;
                });
            } catch (error) {}
        },
        getOtList() {
            return api.get(
                `/admin/api/center/${this.centerId}/salary/ticket/calculate/ot/staff/${this.selectedStaffId}`,
                {
                    params: {
                        startDate: this.startDate,
                        endDate: this.endDate,
                        sortColumn: this.sortColumn,
                        sortType: this.sortType,
                        lessonType: this.lessonType,
                    },
                }
            );
        },
        // 듀엣 정산내역
        async onDuetList() {
            try {
                const { data } = await this.getDuetList();
                this.duet.list = data;

                const obj = {};
                data.forEach((g) => {
                    const key = `${g.ctb_less_dt}_${g.ctb_less_staff_id}_${g.details[0].cls_less_start_tm}_${g.details[0].cls_less_end_tm}`;
                    if (obj[key] === undefined) {
                        obj[key] = [];
                    }
                    g.details[0].editPrice = g.details[0].ctb_bill_price;
                    g.details[0].editHandBillYn = g.details[0].ctb_hand_bill_yn;
                    obj[key].push(g);

                    const keys = Object.keys(obj).sort();
                    this.duet.list = [];
                    for (const k of keys) {
                        this.duet.list.push(obj[k]);
                    }
                });

                this.duetInfo = [];
                for (const d of this.duet.list) {
                    const editPrice = this.getClassTotalBillPrice(d, 'D');
                    let editHandBillYn = true;

                    for (const duet of d) {
                        editHandBillYn = editHandBillYn && duet.details[0].ctb_hand_bill_yn;
                    }

                    this.duet.list = this.duet.list.sort((a, b) => {
                        return a[0].ctb_less_dt < b[0].ctb_less_dt ? -1 : 1;
                    });

                    this.duetInfo.push({
                        orgEditPrice: editPrice,
                        editPrice,
                        orgEditHandBillYn: editHandBillYn,
                        editHandBillYn,
                    });
                }
            } catch (error) {
                console.log(error);
            }
        },
        getDuetList() {
            return api.get(
                `/admin/api/center/${this.centerId}/salary/ticket/calculate/duet/staff/${this.selectedStaffId}`,
                {
                    params: {
                        startDate: this.startDate,
                        endDate: this.endDate,
                        sortColumn: this.sortColumn,
                        sortType: this.sortType,
                        lessonType: this.lessonType,
                    },
                }
            );
        },
        // 그룹 정산내역
        async onGroupList() {
            try {
                const { data } = await this.getGroupList();
                this.group.list = data;
                console.log('group data', data);
                const obj = {};
                data.forEach((g) => {
                    if (g.details) {
                        const key = g.ctb_less_schd_id;
                        if (obj[key] === undefined) {
                            obj[key] = [];
                        }
                        g.details[0].editPrice = g.details[0].ctb_bill_price;
                        g.details[0].editHandBillYn = g.details[0].ctb_hand_bill_yn;
                        obj[key].push(g);

                        const keys = Object.keys(obj).sort();
                        this.group.list = [];

                        for (const k of keys) {
                            this.group.list.push(obj[k]);
                        }
                    } else {
                        g.details = [{}];
                        const key = g.ctb_less_schd_id;
                        if (obj[key] === undefined) {
                            obj[key] = [];
                        }
                        g.details[0].editPrice = 0;
                        g.details[0].editHandBillYn = false;
                        obj[key].push(g);

                        const keys = Object.keys(obj).sort();
                        this.group.list = [];

                        for (const k of keys) {
                            this.group.list.push(obj[k]);
                        }
                    }
                });

                this.group.list = this.group.list.sort((a, b) => {
                    return a[0].ctb_less_dt < b[0].ctb_less_dt ? -1 : 1;
                });

                this.groupInfo = [];
                for (const g of this.group.list) {
                    const editPrice = this.getClassTotalBillPrice(g, 'G');
                    let editHandBillYn = true;

                    for (const group of g) {
                        editHandBillYn = editHandBillYn && group.details[0].ctb_hand_bill_yn;
                    }

                    this.groupInfo.push({
                        ctb_bill_price: editPrice,
                        editPrice,
                        ctb_hand_bill_yn: editHandBillYn,
                        editHandBillYn,
                    });
                }
            } catch (error) {
                console.log(error);
            }
            console.log('this.groupInfo', this.groupInfo);
        },

        getGroupList() {
            return api.get(
                `/admin/api/center/${this.centerId}/salary/ticket/calculate/group/staff/${this.selectedStaffId}`,
                {
                    params: {
                        startDate: this.startDate,
                        endDate: this.endDate,
                        sortColumn: this.sortColumn,
                        sortType: this.sortType,
                        lessonType: this.lessonType,
                    },
                }
            );
        },
        // 출결여부 확인
        convertStatus(type) {
            if (type == 'O') {
                return '출석';
            } else if (type == 'X') {
                return '결석';
            }
            return '미승인';
        },
        // 입력완료 버튼 클릭시
        async postEdit() {
            try {
                this.loading = true;
                const list = [];

                // 개인 부분 반복문
                for (const p of this.person.list) {
                    if (this.isDifferent(p)) {
                        list.push({
                            tickBillId: p.ctb_tick_bill_id,
                            billPrice: p.editPrice,
                            handBillYn: p.editHandBillYn,
                        });
                    }
                }

                // ot 부분 반복문
                for (const o of this.ot.list) {
                    if (this.isDifferent(o)) {
                        list.push({
                            tickBillId: o.ctb_tick_bill_id,
                            billPrice: o.editPrice,
                            handBillYn: o.editHandBillYn,
                        });
                    }
                }

                // Duet 부분 반복문
                for (let i = 0; i < this.duet.list.length; i++) {
                    const d = this.duet.list[i];
                    const info = this.duetInfo[i];
                    for (const t of d) {
                        const duet = t.details[0];
                        if (!['FA', 'CA'].includes(this.DuetLessonPaySetting) && this.isDifferent(duet)) {
                            list.push({
                                tickBillId: duet.ctb_tick_bill_id,
                                billPrice: duet.editPrice,
                                handBillYn: duet.editHandBillYn,
                            });
                        } else if (['FA', 'CA'].includes(this.DuetLessonPaySetting) && this.isDifferent(info)) {
                            list.push({
                                tickBillId: duet.ctb_tick_bill_id,
                                billPrice: info.editPrice,
                                handBillYn: info.editHandBillYn,
                            });
                        }
                    }
                }

                // Group 부분 반복문
                for (let i = 0; i < this.group.list.length; i++) {
                    const g = this.group.list[i];
                    const info = this.groupInfo[i];
                    for (const d of g) {
                        const group = d.details[0];
                        if (this.GroupLessonPaySetting === 'MO' && this.isDifferent(group)) {
                            list.push({
                                tickBillId: group.ctb_tick_bill_id,
                                billPrice: group.editPrice,
                                handBillYn: group.editHandBillYn,
                            });
                        } else if (this.GroupLessonPaySetting !== 'MO' && this.isDifferent(info)) {
                            list.push({
                                tickBillId: group.ctb_tick_bill_id,
                                billPrice: info.editPrice,
                                handBillYn: info.editHandBillYn,
                            });
                        }
                    }
                }
                await this.ticketPriceEdit(list);
                await this.refrechAllList();
                this.loading = false;
                this.payEdit = false;
            } catch (err) {
                this.loading = false;
                console.error(err);
            }
        },
        isDifferent(item) {
            return (
                item.editPrice &&
                (item.editPrice !== item.ctb_bill_price || item.editHandBillYn !== item.ctb_hand_bill_yn)
            );
        },
        // 정산금액을 수정하는 api
        ticketPriceEdit(list) {
            // 스웨거 검색: 이용권정산내역 수정
            return api.put(`/admin/api/center/${this.centerId}/salary/ticket/calculate/modify`, {
                tickBills: list,
            });
        },
        // 시간 형식에 맞게 변환
        convertTm(val) {
            if (val == null || undefined) {
                return '';
            }
            return moment(val).locale('ko').format('YYYY-MM-DD HH:mm:ss (ddd)');
        },
        // 티켓유형
        convertTicket(type) {
            if (type == 'P') {
                return '[개인]';
            } else if (type == 'O') {
                return '[OT]';
            } else if (type == 'D') {
                return '[듀엣]';
            } else if (type == 'G') {
                return '[그룹]';
            } else if (type == 'C') {
                return '[쿠폰]';
            } else if (type == 'T') {
                return '[이용권]';
            }
        },
        // 정산금액 수정
        calPriceEdit() {
            this.payEdit = true;
            alert('정산금액 입력 후 상단의 [금액수정완료] 버튼을 눌러주세요.');
            // for(let i in this.person.list){ //값 세팅
            //     this.editPrice[i] = this.person.list[i].ctb_bill_price;
            //     this.editPriceOt[i] = this.ot.list[i].ctb_bill_price;
            // }
        },
        convertTypeCd(val) {
            switch (val) {
                case 'W':
                    return '주';
                    break;
            }
        },
        convertLessonTm(date, time) {
            let lessonDate = '';
            try {
                const timeArr = time.split(':', 2);
                const hour = timeArr[0];
                const minute = timeArr[1];

                lessonDate = moment(date).hour(hour).minute(minute).locale('ko').format('YYYY-MM-DD HH:mm(ddd)');
            } catch {}
            return lessonDate;
        },
        sum(list) {
            return list.reduce((accumulator, currentValue) => accumulator + currentValue.ctb_bill_price, 0);
        },
        max(list) {
            return list.reduce((accumulator, currentValue) => Math.max(accumulator, currentValue.ctb_bill_price), 0);
        },
        // isMemberStandard(lessonType) { // 해당 강사의 듀엣 및 그룹 이용권의 정산 기준이 회원이면 True이고, 강사이면 False을 반환한다.
        //     return (lessonType === 'D' && (this.DuetLessonPaySetting === 'FP' || this.DuetLessonPaySetting === 'CP')) || (lessonType === 'G' && this.GroupLessonPaySetting === 'MO');
        // },
        getClassTotalBillPrice(list, lessonType) {
            const paySetting = lessonType === 'G' ? this.GroupLessonPaySetting : this.DuetLessonPaySetting;

            if (this.isMemberStandard(paySetting)) {
                return this.sum(list);
            }

            return this.max(list);
        },
        onChangeHandBillYn(event, item) {
            item.editHandBillYn = event.target.checked;
            this.$forceUpdate();
        },
        isMemberStandard(paySetting) {
            return ['FP', 'CP', 'MO'].includes(paySetting);
        },
        onClickDescOrASC(column, division, index) {
            // 수기여부 정렬을 요청할 경우...
            if (column === '수기여부') {
                // 무시한다.
            } else {
                this.tableHeader[index][column.key].sortType = ++this.tableHeader[index][column.key].sortType % 3;
                this.sortColumn = column.key;
                this.sortType =
                    this.tableHeader[index][column.key].sortType === 1
                        ? 'DESC'
                        : this.tableHeader[index][column.key].sortType == 2
                        ? 'ASC'
                        : '';
                // 아니면, 테이블 헤더에 담겨져있는 정보를 토대로, 올림,내림정렬을 설정한다

                if (division == 'person') {
                    this.onPersonList(); // 개인이용권
                }
                if (division == 'ot') {
                    this.onOtList(); // ot list
                }
                if (division == 'duet') {
                    this.onDuetList(); // duet list
                }
                if (division == 'group') {
                    this.onGroupList(); // group list
                }
            }
        },
    },
};
</script>
<style lang="scss"></style>
